import React, { useState } from 'react'
import { Details, Term, Definition } from '../../common/Details'
import { TextClamp } from '../../common/TextClamp'
import { InfoTooltip } from '../../common/Tooltip'
import { UpgradeGroup } from '../../common/Upgrade/UpgradeGroup'
import { IconListGrid, ListItem } from '../../common/IconListGrid'
import { DetailsSection } from '../DetailsSection'

function SummaryDetails({ actorData, ...detailsSectionProps }) {
  const [showAliases, setShowAliases] = useState(false)

  const isFreemiumUser = Object.values(actorData).some(value => value === 'redacted')

  const {
    description,
    aliases,
  } = actorData

  const extractFirstName = (alias = {}) => {
    const name = alias?.name || ''
    const firstName = name.split(' ')[0] || ''
    return firstName
  }

  const newAliases = !isFreemiumUser && aliases.filter((alias, index, self) =>
    index === self.findIndex((a) => extractFirstName(a) === extractFirstName(alias)))

  return (
    <DetailsSection title="Actor Summary" {...detailsSectionProps}>
      <Details>
        <Term>Description</Term>
        <Definition marginTop='8px'>
          <TextClamp>
            {description}
          </TextClamp>
        </Definition>

        {isFreemiumUser &&
          <UpgradeGroup
            layout="row"
            description="In order to view this content, you have to update to Premium. You're currently in the Freemium subscription, and you're missing a lot!"
            titleIcon="list"
            title="Actor Summary"
            height="100%"
          >
            <>
              <Term>Reported As</Term>
            </>
          </UpgradeGroup>
        }

        {(!isFreemiumUser && !!aliases?.length) &&
          <>
            <Term>
              Reported As
              <InfoTooltip tooltip='Associated indicators have also been reported by organizations under the following names' />
            </Term>
            <Definition>
              <IconListGrid
                list={newAliases}
                showItems={showAliases}
                setShowItems={setShowAliases}
                displayLimit={4}
                cellWidths={['100%', '50%', '25%']}
                useExtraIcons
                renderItem={(item) => <ListItem>{item.name}</ListItem>}
              />
            </Definition>
          </>
        }
      </Details>
    </DetailsSection>
  )
}

export default SummaryDetails
